<template>
    <!-- 问卷统计 -->
    <div>
        <div class="stat-container">
            <div class="stat-content">
                <go-back content="问卷统计" style="padding: 30px 0 30px 0"/>
                <!-- 数据概况 -->
                <headline title="数据概况"/>
                <div class="stat-content--general">
                    <div class="stat-content--general--new">
                        <div>今日新增数据</div>
                        <span>{{statData.stuCountDate}}</span>
                    </div>
                    <div class="stat-content--general--total">
                        <div>数据总量</div>
                        <span>{{statData.numCount}}</span>
                    </div>
                    <div class="stat-content--general--duration">
                        <div>平均答题时长</div>
                        <span>{{statData.AvgTime | getTimerStr("{h}时{i}分{s}秒")}}</span>
                    </div>
                </div>
                <!-- 统计报告 -->
                <el-row type="flex" justify="space-between" align="middle">
                    <headline title="统计报告"/>
                    <el-button type="primary"
                               @click.stop="handleShare"
                               icon="el-icon-share"
                               style="height: 30px; line-height: 5px; padding: 0; width: 80px">分享</el-button>
                </el-row>
                <question-stat :question="question"
                               :key="question.id"
                               :number="index + 1"
                               v-for="(question, index) in statData.questionList"/>
            </div>
            <share ref="share"
                   :query="$route.query"
                   :questionnaire-title="$route.query.title"
                   :is-show-back-question-list="false"/>
        </div>
        <bottomnav/>
    </div>
</template>

<script>
// 标题
import headline from "@/components/headline/headline";
// 问卷试题统计
import QuestionStat from "@/components/questionStat";
import { getStatData } from "@/api/new-question-iteration/question-library"
import { uuid, getTimerStr, toFixed, numberToWord } from "@/utils";
import { QUESTION_NUM_VAL, isUrl, QUESTION_VAL } from "@/utils/question-config";
import share from "@/views/manage/psq/msq/create-empty/cpns/share";
import NP from "number-precision"
import Bottomnav from "@/components/bottomnav"; // 引入该库解决浮点数精度问题
export default {
    name: "Stat",
    components: {
        Bottomnav,
        headline,
        QuestionStat,
        share
    },
    data() {
        return {
            statData: {}
        }
    },
    filters: {
        getTimerStr
    },
    created() {
        this.getStatData()
    },
    methods: {
        // 获取统计数据
        getStatData() {
            const Qid = this.$route.query.Qid
            if (!Qid) return
            getStatData(Qid).then(res => {
                const { AvgTime, numCount, stuCountDate, QuestionnaireDetailViewlist = [] } = res || {}
                const questionList = QuestionnaireDetailViewlist.map(item => {
                    const { Title, Options, Type, Remark, count, IsMustAnswer, ...otherProps } = item
                    let countMapObj = Object.create(null)
                    // 最后一个选择的项
                    let lastWord
                    if (Array.isArray(count)) {
                        // 将count转为对象
                        countMapObj = count.reduce((preVal, curVal) => {
                            const [key, value] = Object.entries(curVal)[0]
                            if (key) {
                                preVal[key] = parseInt(value)
                            }
                            return preVal
                        }, Object.create(null))
                        // 升序排列key
                        const ascSort = Object.keys(countMapObj).sort((a, b) => a.charCodeAt(0) - b.charCodeAt(0))
                        lastWord = ascSort[ascSort.length - 1]
                    }
                    const isHasOptionsQuestion = [QUESTION_VAL.single, QUESTION_VAL.multiple].includes(QUESTION_NUM_VAL[Type])
                    const optionsQuestionTotal = Object.values(countMapObj).reduce((preVal, curVal) => {
                        preVal = preVal + curVal
                        return preVal
                    }, 0)
                    let percentage = 0
                    const questionOptions = (isHasOptionsQuestion && typeof Options === "string" && Options.split("|"))
                    return {
                        stem: Title,
                        options: Array.isArray(questionOptions) ? questionOptions.map((item, index) => {
                            const word = numberToWord(index + 1)
                            const currentPercentage = parseFloat((toFixed((((countMapObj[word] || 0) / optionsQuestionTotal) * 100), 2))) || 0
                            // 解决浮点数精度问题
                            percentage = word === lastWord ? percentage : NP.plus(percentage, currentPercentage)
                            return {
                                type: isUrl(item) ? "image" : "text",
                                text: item,
                                count: countMapObj[word] || 0,
                                percentage: word === lastWord ? (optionsQuestionTotal === 0 ? 0 : NP.minus(100, percentage)) : currentPercentage
                            }
                        }) : Options,
                        type: QUESTION_NUM_VAL[Type],
                        remark: Remark,
                        participants: isHasOptionsQuestion ? optionsQuestionTotal : item.answer.length, // 参与人数
                        required: !!IsMustAnswer,
                        count,
                        no: uuid(5),
                        ...otherProps
                    }
                })
                console.log(questionList, "questionList");
                this.statData = {
                    AvgTime,
                    numCount,
                    stuCountDate,
                    questionList
                }
            })
        },
        handleShare () {
            this.$refs.share.open()
        }
    }
}
</script>

<style scoped lang="less">
@base-radius: 12px;
.stat-content {
    padding-left: calc(18.5% + 20px);
    padding-right: calc(18.5% + 20px);
    box-sizing: border-box;

    &--general {
        background-color: #fff;
        padding: 40px 0;
        box-sizing: border-box;
        display: flex;
        width: 100%;
        border-radius: @base-radius;

        &--new, &--total, &--duration {
            flex: 1;
            text-align: center;

            > div:first-child {
                margin-bottom: 10px;
                font-weight: 400;
                color: #868EA1;
                font-size: 14px;
            }

            > span {
                font-size: 24px;
                font-weight: 600;
            }
        }
    }
}
</style>
